import * as React from "react";

import {cn} from "@/lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  startContent?: React.ReactNode;
  endContent?: React.ReactNode;
  containerClassName?: string;
  endContentClassName?: string;
  error?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      containerClassName = "",
      endContentClassName = "",
      type,
      startContent,
      endContent,
      error,
      ...props
    },
    ref,
  ) => {
    return (
      <div className={cn("relative", containerClassName)}>
        {startContent && (
          <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
            {startContent}
          </div>
        )}
        <input
          type={type}
          className={cn(
            "flex h-10 w-full rounded-md border border-input bg-background py-2 px-4 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none  focus-visible:border-primary disabled:cursor-not-allowed",
            {"pl-8": startContent, "pr-8": endContent},
            error &&
              "placeholder:text-destructive border-destructive focus-visible:ring-0",
            className,
          )}
          ref={ref}
          {...props}
        />
        {endContent && (
          <div
            className={cn(
              "absolute right-3 top-1/2 transform -translate-y-1/2",
              endContentClassName,
            )}
          >
            {endContent}
          </div>
        )}
      </div>
    );
  },
);
Input.displayName = "Input";

export {Input};
